export const en = {
    'deleted-success': 'Retargeting list has been deleted',
    'error-delete-retargeting-list-item': 'Unable to delete the retargeting list'
};
